import {
	PUBLIC_PAGE_API_ENDPOINT,
	PUBLIC_MYPAGES_API_ENDPOINT,
} from "../../constants"

export const saveArticle = (guidValue: string, isSavedArticle = false) => {
	const url =
		PUBLIC_PAGE_API_ENDPOINT +
		PUBLIC_MYPAGES_API_ENDPOINT +
		`/articles?contentGuid=${guidValue}`

	return fetch(url, {
		method: isSavedArticle ? "DELETE" : "PUT",
	}).then((res) => {
		return {
			success: res.status === 200 || res.status === 204,
			statusCode: res.status,
		}
	})
}

export const onFavButtonClick = async (
	guidValue: string,
	isSavedArticle: boolean,
	setFilled: React.Dispatch<React.SetStateAction<boolean>>
) => {
	const result = await saveArticle(guidValue, isSavedArticle)

	if (result.success) {
		setFilled((f) => !f)
	} else {
		console.error(
			`Request to save article failed with status code ${result.statusCode}`
		)
	}
}
